document.addEventListener('DOMContentLoaded', () => {

// Mobile Menu Collapse
  const mobileMenuTrigger = document.querySelector('.site-header .menu-trigger');
  const mobileMenu = document.querySelector('.site-header .primary-menu');
  if ( mobileMenuTrigger ) {
    mobileMenuTrigger.addEventListener('click', function (){
      mobileMenu.classList.toggle('shown');
      mobileMenuTrigger.classList.toggle('is-active');
      document.querySelector('body').classList.toggle('menu-shown');
    });
  }

// Main Navigation Submenu
  document.querySelectorAll('.primary-menu .menu-item-has-children > a')?.forEach(link => {
    link.addEventListener('click', event => {
      if (window.innerWidth < 1280) {
        const submenu = link.nextElementSibling;
        const isShown = submenu?.classList.contains('shown');

        if (!isShown) {
          event.preventDefault();
          if (submenu && submenu.classList.contains('sub-menu')) {
            link.classList.add('active');
            submenu.classList.add('shown');
          }
        }
      }
    });
  });

// Modify Header on Scroll
  let scrollpos = window.scrollY;
  const header = document.querySelector(".site-header");

  function compactHeader() {
    if (scrollpos >= 10) {
      header.classList.add("compact");
    }
    else {
      header.classList.remove("compact");
    }
  }
  window.addEventListener('scroll', function() {
    scrollpos = window.scrollY;
    compactHeader();
  });
  window.onload = (event) => {
    compactHeader();
  };


  // Tabs
  const tabSections = document.querySelectorAll('.tabbed-content');

  tabSections.forEach(section => {
    const tabsNav = section.querySelectorAll('.tabs-navigation a');
    const tabs = section.querySelectorAll('.tabs .tab');

    const select = document.createElement('select');
    select.classList.add('tabs-select', 'block', 'sm:hidden', 'appearance-none', 'font-bold', 'rounded-tr-3xl', 'px-4', 'pt-3', 'pb-12', 'relative', '-right-6', '-bottom-12');

    tabsNav.forEach((tabLink, index) => {
      const option = document.createElement('option');
      option.value = index;
      option.textContent = tabLink.textContent;
      if (tabLink.classList.contains('active')) {
        option.selected = true;
      }
      select.appendChild(option);
    });

    const navContainer = section.querySelector('.tabs-navigation');
    const navWrapper = navContainer.closest('.container'); // вот она!

    if (navWrapper) {
      navWrapper.appendChild(select);
    }

    tabsNav.forEach((tabLink, index) => {
      tabLink.addEventListener('click', event => {
        event.preventDefault();

        activateTab(index);
        select.value = index;
      });
    });

    select.addEventListener('change', () => {
      const index = parseInt(select.value);
      activateTab(index);
    });

    function activateTab(index) {
      tabsNav.forEach(link => link.classList.remove('active'));
      tabs.forEach(tab => tab.classList.remove('active'));

      if (tabsNav[index]) {
        tabsNav[index].classList.add('active');
      }
      if (tabs[index]) {
        tabs[index].classList.add('active');
      }
    }
  });

});
